import Vue from "vue";
import { localize, extend } from "vee-validate";
import es from "vee-validate/dist/locale/es.json";
import { ValidationProvider } from "vee-validate";
import { ValidationObserver } from "vee-validate";
import { required, email, double, numeric, min, min_value, max, max_value, length } from "vee-validate/dist/rules";

localize("es", es);

extend("required", required);
extend("email", email);
extend("double", double);
extend("numeric", numeric);
extend("min", min);
extend("min_value", min_value);
extend("max", max);
extend("max_value", max_value);
extend("length", length);

extend("time", {
  validate: (value) => {
    let regExp = /^(0[0-9]|1[0-9]|2[0-3]):[0-5][0-9]$/; // HH:mm
    return regExp.test(value);
  },
  message: "Ingresa una hora válida. Ej.: 13:00",
});

extend("time2", {
  validate: (value) => {
    let regExp = /^(?<hours>0?[0-9]|1[0-9]|2[0-3])(:(?<minutes>[0-5][0-9]))?$/; // HH:mm | h:mm | h
    return regExp.test(value);
  },
  message: "Ingresa una hora válida. Ej.: 13:00",
});

extend("ruc", {
  validate: (value) => {
    let regExp = /^[1|2][0-9]{10}$/;
    return regExp.test(value);
  },
  message: "Ingrese un RUC válido.",
});

extend("number", {
  validate: (value) => {
    let regExp = /^\d*\.?\d*$/;
    return regExp.test(value);
  },
  message: "Debe ser un número válido",
});

extend("checked", {
  validate: (value) => {
    return value == true;
  },
  message: "Debe de marcar esta casilla",
});

extend("positive", {
  validate: (value) => {
    return Number(value) >= 0;
  },
  message: "Debe ser positivo",
});

extend("greater", {
  validate: (input, { val }) => {
    return Number(input) > Number(val);
  },
  params: ["val"],
  message: "Debe ser mayor que {val}",
});

Vue.component("ValidationObserver", ValidationObserver);
Vue.component("ValidationProvider", ValidationProvider);
